import * as React from "react";
function SvgBubbleComment(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      >
        <path d="M16 29l-4-6H3a2 2 0 01-2-2V5a2 2 0 012-2h26a2 2 0 012 2v16a2 2 0 01-2 2h-9zM6 9h20M6 15h8" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubbleComment);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
